module.exports = __webpack_public_path__ + "static/media/freelancer-highlight-2.bd384a53.webp";